import React from 'react';
import { withTranslation } from 'react-i18next';

class Shortcuts extends React.Component {
  constructor(props) {
    super(props);

    // binding
    this.handleShowSearchWindow = this.handleShowSearchWindow.bind(this);
    this.shortcutClick = this.shortcutClick.bind(this);
    this.state = {
      showInProcess: false,
    };
  }

  componentDidMount() {
    this.componentDidUpdate();
  }

  componentDidUpdate() {
    /* const shortcuts = document.getElementById("shortcuts-wrapper")
        //const size = shortcuts[4].width();
        const size = '1000px'
        shortcuts.scrollRight = '250px'
        shortcuts.scrollLeft = '500px';
        //alert(size)*/
  }

  handleShowSearchWindow(event, show) {
    event.stopPropagation();

    this.props.openSearchClicked('0', show);
    const event_name = 'ShortcutAdvancedSearch';

    // add GTM custom event
    if (window['google_tag_manager']) {
      console.log('GTM event: ' + event_name);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: event_name,
        eventTimeout: 2000,
        pageUrl: window.location,
        pageTitle: window.title,
      });
    }
  }

  shortcutClick(event, event_name, url) {
    event.preventDefault();
    event.stopPropagation();

    const adults = this.props.filters.adults;
    const children = this.props.filters.children;
    const teens = this.props.filters?.teens;
    const infants = this.props.filters?.infants;

    // add GTM custom event
    if (window['google_tag_manager']) {
      console.log('GTM event: ' + event_name);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: event_name,
        eventTimeout: 2000,
        target_url: url,
        pageUrl: window.location,
        pageTitle: window.title,
        eventCallback: () => {
          window.location = url;
        },
      });
    }

    if (!(adults == 2 && children == 0 && teens == 0 && infants == 0))
      url += `?adults=${adults}&children=${children}&teens=${teens}&infants=${infants}`;

    console.log(`shortcutClick() -> ${event_name} ${url}`);
    window.location.href = url;
  }

  render() {
    if (!this.props.hidden)
      return (
        <>
          <div
            id="shortcuts"
            className={
              this.props?.active || this.props?.searchResults
                ? 'shortcuts-block mobile'
                : 'shortcuts-block mobile'
            }
          >
            <div className="wrapper" id="shortcuts-wrapper">
              <div
                className={
                  this.props?.active == 'best' || this.props?.active == 'home'
                    ? 'shortcut selected'
                    : 'shortcut'
                }
              >
                <a
                  href="/best-deals/"
                  title={this.props.t('shortcuts.links.bestDeals.title')}
                  onClick={(e) => {
                    this.shortcutClick(e, 'ShortcutBestDeals', '/best-deals/');
                  }}
                >
                  <div className="image">
                    <div
                      className="rectangle"
                      style={{
                        backgroundImage:
                          'url("https://cdn.cookiecrumbz.com/images/destinations/paris.jpg")',
                      }}
                      alt={this.props.t('shortcuts.links.bestDeals.alt')}
                    />
                    <div className="selector"></div>
                  </div>
                  <div className="label">{this.props.t('shortcuts.links.bestDeals.label')}</div>
                </a>
              </div>

              <div
                className={this.props?.active == 'last-minute' ? 'shortcut selected' : 'shortcut'}
              >
                <a
                  href="/last-minute/"
                  title={this.props.t('shortcuts.links.lastMinute.title')}
                  onClick={(e) => {
                    this.shortcutClick(e, 'ShortcutLastMinute', '/last-minute/');
                  }}
                >
                  <div className="image">
                    <div
                      className="rectangle"
                      style={{
                        backgroundImage:
                          'url("https://cdn.cookiecrumbz.com/images/destinations/venice.jpg")',
                      }}
                      alt={this.props.t('shortcuts.links.lastMinute.alt')}
                    />
                    <div className="selector"></div>
                  </div>
                  <div className="label">{this.props.t('shortcuts.links.lastMinute.label')}</div>
                </a>
              </div>

              <div className={this.props?.active == 'xmas' ? 'shortcut selected' : 'shortcut'}>
                <a
                  href="/xmas-deals/"
                  title={this.props.t('shortcuts.links.xmas.title')}
                  onClick={(e) => {
                    this.shortcutClick(e, 'ShortcutXmas', '/xmas-deals/');
                  }}
                >
                  <div className="image">
                    <div
                      className="rectangle"
                      style={{
                        backgroundImage:
                          'url("https://cdn.cookiecrumbz.com/images/destinations/vienna.jpg")',
                      }}
                      alt={this.props.t('shortcuts.links.xmas.alt')}
                    />
                    <div className="selector"></div>
                  </div>
                  <div className="label">{this.props.t('shortcuts.links.xmas.label')}</div>
                </a>
              </div>

              {/*
                        <div className={this.props?.active=='hot'?'shortcut selected':'shortcut'}>
                            <a href="/hot-deals/" title={this.props.t('shortcuts.links.hotDeals.title')}  onClick={e=> {this.shortcutClick(e, 'ShortcutHotDeals', '/hot-deals/')}}>
                                <div className="image">
                                    <div className="rectangle" style={{backgroundImage:'url("https://cdn.cookiecrumbz.com/images/hot-air-balloon2.jpg")'}} alt={this.props.t('shortcuts.links.hotDeals.alt')} />
                                    <div className="selector"></div>
                                </div>
                                <div className="label">
                                    {this.props.t('shortcuts.links.hotDeals.label')}
                                </div>
                            </a>
                        </div>
                        */}

              {/*
                    <div className={this.props?.active=='xmas'?'shortcut selected new':'shortcut new'}>
                        <a href="/xmas-deals/" title={this.props.t('shortcuts.links.xmas.title')}  onClick={e=> {this.shortcutClick(e, 'ShortcutXmas', '/xmas-deals/')}}>
                            <div className="image">
                                <div className="rectangle" style={{backgroundImage:'url("/images/shortcuts/xmas.jpg")'}} alt={this.props.t('shortcuts.links.xmas.alt')} />
                                <div className="selector"></div>
                            </div>
                            <div className="label">
                                {this.props.t('shortcuts.links.xmas.label')}
                            </div>
                        </a>
                    </div>
                    <div className={this.props?.active=='winter'?'shortcut selected new':'shortcut new'}>
                        <a href="/winter-deals/" title={this.props.t('shortcuts.links.winter.title')}  onClick={e=> {this.shortcutClick(e, 'ShortcutWinter', '/winter-deals/')}}>
                            <div className="image">
                                <div className="rectangle" style={{backgroundImage:'url("/images/shortcuts/xmas.jpg")'}} alt={this.props.t('shortcuts.links.winter.alt')} />
                                <div className="selector"></div>
                            </div>
                            <div className="label">
                                {this.props.t('shortcuts.links.winter.label')}
                            </div>
                        </a>
                    </div>
*/}

              {/*
                        <div className={this.props?.active=='sukkot-vacation'?'shortcut sukkot selected':'shortcut sukkot new'} >
                            <a href="/sukkot-vacation-deals/" title={this.props.t('shortcuts.links.sukkot.title')} onClick={e=> {this.shortcutClick('ShortcutSukkot', '/sukkot-vacation-deals/')}}>
                                <div className="image">
                                    <div className="rectangle" style={{backgroundImage:'url("https://cdn.cookiecrumbz.com/images/destinations/amsterdam.jpg")'}} alt={this.props.t('shortcuts.links.sukkot.alt')} />
                                </div>
                                <div className="label">
                                    {this.props.t('shortcuts.links.sukkot.label')}
                                </div>
                            </a>
                        </div>
			*/}

              {/*
                        <div className={this.props?.active=='waterpark'?'shortcut selected new':'shortcut new'}>
                            <a href="/waterparks/" title={this.props.t('shortcuts.links.waterpark.title')}  onClick={e=> {this.shortcutClick(e, 'ShortcutWaterparks', '/waterparks/')}}>
                                <div className="image">
                                    <div className="rectangle" style={{backgroundImage:'url("/images/waterpark.jpg")'}} alt={this.props.t('shortcuts.links.waterpark.alt')} />
                                    <div className="selector"></div>
                                </div>
                                <div className="label">
                                    {this.props.t('shortcuts.links.waterpark.label')}
                                </div>
                            </a>
                        </div>
                         */}

              {/*
                        <div className={this.props?.active=='passover-vacation-deals' || this.props?.active=='passover' || this.props?.active=='passover-deals' ?'shortcut selected new':'shortcut new'}>
                            <a href="/passover-vacation-deals/" title={this.props.t('shortcuts.links.passover.title')}  onClick={e=> {this.shortcutClick(e, 'ShortcutPassover', '/passover-vacation-deals/')}}>
                                <div className="image">
                                    <div className="rectangle" style={{backgroundImage:'url("https://cdn.cookiecrumbz.com/images/destinations/barcelona.jpg")'}} alt={this.props.t('shortcuts.links.passover.alt')} />
                                    <div className="selector"></div>
                                </div>
                                <div className="label">
                                    {this.props.t('shortcuts.links.passover.label')}
                                </div>
                            </a>
                        </div>

                        */}
              {/* Season over — summer-vacation shortcut hidden.
              <div
                className={
                  this.props?.active == 'summer-vacation'
                    ? 'shortcut summer-vacation selected'
                    : 'shortcut summer-vacation'
                }
              >
                <a
                  href="/summer-vacation/"
                  title={this.props.t('shortcuts.links.summerVacation.title')}
                  onClick={(e) => {
                    this.shortcutClick(e, 'ShortcutSummerVacation', '/summer-vacation/');
                  }}
                >
                  <div className="image">
                    <div
                      className="rectangle"
                      style={{ backgroundImage: 'url("/images/waterpark.jpg")' }}
                      alt={this.props.t('shortcuts.links.summerVacation.alt')}
                    />
                    <div className="selector"></div>
                  </div>
                  <div className="label">
                    {this.props.t('shortcuts.links.summerVacation.label')}
                  </div>
                </a>
              </div>
              */}

              {/* Season over — waterparks shortcut hidden; earlybirds takes this slot.
              <div className={this.props?.active == 'waterpark' ? 'shortcut selected' : 'shortcut'}>
                <a
                  href="/waterparks/"
                  title={this.props.t('shortcuts.links.waterpark.title')}
                  onClick={(e) => {
                    this.shortcutClick(e, 'ShortcutWaterparks', '/waterparks/');
                  }}
                >
                  <div className="image">
                    <div
                      className="rectangle"
                      style={{
                        backgroundImage:
                          'url("https://cdn.cookiecrumbz.com/images/destinations/antalya.jpg")',
                      }}
                      alt={this.props.t('shortcuts.links.waterpark.alt')}
                    />
                    <div className="selector"></div>
                  </div>
                  <div className="label">{this.props.t('shortcuts.links.waterpark.label')}</div>
                </a>
              </div>
              */}

              <div
                className={this.props?.active == 'earlybirds' ? 'shortcut selected' : 'shortcut'}
              >
                <a
                  href="/early-birds/"
                  title={this.props.t('shortcuts.links.earlybirds.title')}
                  onClick={(e) => {
                    this.shortcutClick(e, 'ShortcutEarlyBirds', '/early-birds/');
                  }}
                >
                  <div className="image">
                    <div
                      className="rectangle"
                      style={{
                        backgroundImage:
                          'url("https://cdn.cookiecrumbz.com/images/destinations/london.jpg")',
                      }}
                      alt={this.props.t('shortcuts.links.earlybirds.alt')}
                    />
                    <div className="selector"></div>
                  </div>
                  <div className="label">{this.props.t('shortcuts.links.earlybirds.label')}</div>
                </a>
              </div>

              <div className={this.props?.active == 'weekends' ? 'shortcut selected' : 'shortcut'}>
                <a
                  href="/weekends/"
                  title={this.props.t('shortcuts.links.weekends.title')}
                  onClick={(e) => {
                    this.shortcutClick(e, 'ShortcutWeekendDeals', '/weekends/');
                  }}
                >
                  <div className="image">
                    <div
                      className="rectangle"
                      style={{
                        backgroundImage:
                          'url("https://cdn.cookiecrumbz.com/images/destinations/rome.jpg")',
                      }}
                      alt={this.props.t('shortcuts.links.weekends.alt')}
                    />
                    <div className="selector"></div>
                  </div>
                  <div className="label">{this.props.t('shortcuts.links.weekends.label')}</div>
                </a>
              </div>

              <div className={this.props?.active == 'luxury' ? 'shortcut selected' : 'shortcut'}>
                <a
                  href="/luxury/"
                  title={this.props.t('shortcuts.links.luxury.title')}
                  onClick={(e) => {
                    this.shortcutClick(e, 'Shortcut5Stars', '/luxury/');
                  }}
                >
                  <div className="image">
                    <div
                      className="rectangle"
                      style={{
                        backgroundImage:
                          'url("https://cdn.cookiecrumbz.com/images/destinations/prague.jpg")',
                      }}
                      alt={this.props.t('shortcuts.links.luxury.alt')}
                    />
                    <div className="selector"></div>
                  </div>
                  <div className="label">{this.props.t('shortcuts.links.luxury.label')}</div>
                </a>
              </div>

              {/*
                        <div className={this.props?.active=='summer-family'?'shortcut summer-family selected':'shortcut summer-family new'} >
                            <a href="/summer-family/" title={this.props.t('shortcuts.links.summerFamily.title')} onClick={e=> {this.shortcutClick(e, 'ShortcutSummerFamily', '/summer-family/')}}>
                                <div className="image">
                                    <div className="rectangle" style={{backgroundImage:'url("https://cdn.cookiecrumbz.com/images/destinations/paris.jpg")'}} alt={this.props.t('shortcuts.links.summerFamily.alt')} />
                                    <div className="selector"></div>
                                </div>
                                <div className="label">
                                    {this.props.t('shortcuts.links.summerFamily.label')}
                                </div>
                            </a>
                        </div>



                        <div className={this.props?.active=='all-inclusive'?'shortcut all-inclusive selected':'shortcut all-inclusive new'} >
                            <a href="/all-inclusive-deals/" title={this.props.t('shortcuts.links.allInclusive.title')} onClick={e=> {this.shortcutClick('ShortcutAllInclusive', '/all-inclusive-deals/')}}>
                                <div className="image">
                                <div className="rectangle" style={{backgroundImage:'url("https://cdn.cookiecrumbz.com/images/destinations/papxhos.jpg")'}} alt={this.props.t('shortcuts.links.allInclusive.alt')} />
                                    <div className="selector"></div>
                                </div>
                                <div className="label">
                                    {this.props.t('shortcuts.links.allInclusive.label')}
                                </div>
                            </a>
                        </div>


                        <div className={this.props?.active=='passover-vacation'?'shortcut passover selected':'shortcut passover new'} >
                            <a href="/passover-vacation-deals/" title={this.props.t('shortcuts.links.passover.title')} onClick={e=> {this.shortcutClick(e, 'ShortcutPassover', '/passover-vacation-deals/')}}>
                                <div className="image">
                                <div className="rectangle" style={{backgroundImage:'url("https://cdn.cookiecrumbz.com/images/destinations/amsterdam.jpg")'}} alt={this.props.t('shortcuts.links.passover.alt')} />
                                    <div className="selector"></div>
                                </div>
                                <div className="label">
                                    {this.props.t('shortcuts.links.passover.label')}
                                </div>
                            </a>
                        </div>


                        <div className={this.props?.active=='summer-vacation'?'shortcut summer-vacation selected':'shortcut summer-vacation'} >
                            <a href="/summer-vacation/" title={this.props.t('shortcuts.links.summerVacation.title')} onClick={e=> {this.shortcutClick(e, 'ShortcutSummerVacation','/summer-vacation/')}}>
                                <div className="image">
                                    <div className="rectangle" style={{backgroundImage:'url("https://cdn.cookiecrumbz.com/images/destinations/nice.jpg")'}} alt={this.props.t('shortcuts.links.summerVacation.alt')} />
                                    <div className="selector"></div>
                                </div>
                                <div className="label">
                                    {this.props.t('shortcuts.links.summerVacation.label')}
                                </div>
                            </a>
                        </div>
                        */}

              <div className={this.props?.active == 'one-week' ? 'shortcut selected' : 'shortcut'}>
                <a
                  href="/one-week/"
                  title={this.props.t('shortcuts.links.oneWeek.title')}
                  onClick={(e) => {
                    this.shortcutClick(e, 'ShortcutOneWeek', '/one-week/');
                  }}
                >
                  <div className="image">
                    <div
                      className="rectangle"
                      style={{
                        backgroundImage:
                          'url("https://cdn.cookiecrumbz.com/images/destinations/budapest.jpg")',
                      }}
                      alt={this.props.t('shortcuts.links.oneWeek.alt')}
                    />
                    <div className="selector"></div>
                  </div>
                  <div className="label">{this.props.t('shortcuts.links.oneWeek.label')}</div>
                </a>
              </div>

              <div
                className={
                  this.props?.active == 'search' ? 'shortcut search selected' : 'shortcut search'
                }
              >
                <span
                  href="#deals"
                  title={this.props.t('shortcuts.links.search.title')}
                  onClick={(e) => {
                    this.handleShowSearchWindow(e, false);
                  }}
                >
                  <div className="image">
                    <div
                      className="rectangle"
                      style={{
                        backgroundPositionX: 'center',
                        backgroundImage:
                          'url("https://st2.depositphotos.com/3538103/9751/v/600/depositphotos_97511882-stock-illustration-search-flat-design-icon.jpg")',
                      }}
                      alt={this.props.t('shortcuts.links.search.alt')}
                    />
                    <div className="selector"></div>
                  </div>
                  <div className="label">{this.props.t('shortcuts.links.search.label')}</div>
                </span>
              </div>
            </div>
          </div>
        </>
      );
    else return <></>;
  }
}

export default withTranslation()(Shortcuts);
